/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export const environment = {
  production: false,
  // API_URL: 'http://homologacao.portaletutor.com.br:8080/protocolos-0.0.1',
  // API_URL: 'http://192.168.100.12:8080/protocolos-0.0.1',
  API_URL: "https://protocolos.portaletutor.com.br/protocolos-0.0.1",
  // API_URL: "http://localhost:8080/protocolos-0.0.1",

};
